import { useCallback, useEffect, useRef, useState } from 'react';

import Breadcrumbs from '../../../coreComponents/breadcrumbs';
import { useTranslation } from 'react-i18next';
import { Button, Card, CardBody, Col, Container, Nav, NavItem, NavLink } from 'reactstrap';

import { getCrmControlHistoryTableColumns } from '../../../data/formsAndTable/tables/dataTables/DataSource';

import Swal from 'sweetalert2';
import { CrmControlItem, CrmControlStatus } from '../../../types/Control';
import CommentFileModal, { PreviewItem } from '../../commetFileModal';
import { validateImages } from '../../../lib/filesUtils';
import { ServerFile, usePreviews } from '../../../hooks/usePreviews';

import CommonModal from '../../uiKits/modal/common/CommonModal';
import { useCrmControlData } from './hooks/useCrmControlData';
import { useCrmControlActions } from './hooks/useCrmControlActions';
import { useValidateStatusData } from './hooks/useValidateStatusData';
import { useSwalNotification } from '../../../hooks/useSwalNotification';
import { StatusEditorModal } from '../../uiKits/modal/StatusEditorModal/StatusEditorModal';
import { CrmControlTable } from './components/table/CrmControlTable';
import { StatusHistoryModal } from '../../uiKits/modal/statusHistory/StatusHistoryModal';
import { StatusHistoryItem } from '../../../types/Tables';
import { CrmHeadingTooltip } from './components/CrmHeadingTooltip';

const controlsTabs = ['overdues'];
const CrmComntrol = () => {
  const [showAddDetailsModal, setShowAddDetailsModal] = useState(false);
  const [openNewActionModal, setOpenNewActionModal] = useState(false);

  const [isOpenHistoryModal, setIsOpenHistoryModal] = useState(false);
  const [crmControlId, setCrmControlId] = useState<number | null>(null);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const commentRef = useRef<HTMLInputElement | HTMLTextAreaElement | null>(null);
  const [previewFiles, setPreviewFiles] = useState<ServerFile[]>([]);
  const [comment, setComment] = useState('');
  const [uploadErrors, setUploadErrors] = useState<string[]>([]);
  const [submitting, setSubmitting] = useState(false);
  const [selectedAction, setSelectedAction] = useState<{
    id: number;
    statusName: string;
    colorCode: string;
  } | null>(null);
  const [newActionName, setNewActionName] = useState<string>('');
  const [isEditingAction, setIsEditingAction] = useState<boolean>(false);
  const [editActionName, setEditActionName] = useState<string>('');
  const [lastAddedAction, setLastAddedAction] = useState<{
    id: number;
    statusName: string;
    colorCode: string;
    source: string;
  } | null>(null);
  const [crmItemSource, setCrmItemSource] = useState<string>('');
  const [chosenColor, setChosenColor] = useState<string>('#ffffff');
  // const [colorInputValue, setColorInputValue] = useState<string>('#ffffff');
  const [validationError, setValidationError] = useState<string>('');

  const [historyStatusDetails, setHistoryStatusDetails] = useState<StatusHistoryItem[]>([]);

  const { t } = useTranslation();
  const viewerTz = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const {
    overdues,
    crmControlStatuses,
    page,
    setPage,
    perPage,
    setPerPage,
    sort,
    setSort,
    sortKey,
    setSortKey,
    search,
    setSearch,
    totalRows,
    statusFilter,
    setStatusFilter,
  } = useCrmControlData();

  const { saveEditStatus, submitComment, addNewStatus, deleteStatusConfirmed } =
    useCrmControlActions();
  const { validateStatusData } = useValidateStatusData();
  const { showSwalNotification } = useSwalNotification();

  const dropDownContentForModal = (() => {
    const base = crmControlStatuses ?? [];

    if (!lastAddedAction || !lastAddedAction.id) return base;
    return [lastAddedAction, ...base.filter((s: any) => s.id !== lastAddedAction.id)];
  })();

  const makeAbs = useCallback(
    (rel?: string) =>
      rel ? `${process.env.REACT_APP_BACKEND_STATIC}/${rel}` : 'data:image/gif;base64,R0lG...',
    [],
  );
  const { previews, addFiles, removePreview, clearNonExisting, newFiles } = usePreviews(
    previewFiles,
    makeAbs,
  );
  useEffect(() => {
    if (crmControlStatuses && crmControlStatuses.length > 0) {
      console.log('crmControlStatuses', crmControlStatuses);
      const defaultTab = crmControlStatuses.find(
        (status: CrmControlItem) => status.statusName === 'default',
      )
        ? crmControlStatuses.find((status: CrmControlItem) => status.statusName === 'default')!.id
        : 0;
      console.log('defaultTab', defaultTab);
      setStatusFilter({ id: defaultTab });
      const storedTab = localStorage.getItem('stored-crm-control-status-tabs');
    }
  }, []);
  const handleModalOpen = (id: number, source: string) => {
    setCrmControlId(id);
    setCrmItemSource(source);
    const selectedUser =
      overdues?.items.find((item: CrmControlItem) => item.controlId === id) ?? null;
    setPreviewFiles([]);
    const statusFromDB = selectedUser
      ? {
          id: Number(selectedUser.actionId),
          statusName: selectedUser.statusName,
          colorCode: selectedUser.colorCode,
        }
      : null;

    // If a status was added in this session prefer that as preselected, otherwise use DB status
    // setSelectedAction(
    //   lastAddedAction
    //     ? {
    //         id: Number(lastAddedAction.id),
    //         statusName: lastAddedAction.statusName,
    //         colorCode: lastAddedAction.colorCode,
    //       }
    //     : statusFromDB,
    // );
    setSelectedAction(statusFromDB);
    setShowAddDetailsModal(true);
  };
  const handleHistoryOpen = (controlId: number) => {
    const selectedUser =
      overdues?.items.find((item: CrmControlItem) => item.controlId === controlId) ?? null;
    if (!selectedUser) return;
    const currentStatus = {
      action: selectedUser.actionId,
      actionName: selectedUser.statusName,
      colorCode: selectedUser.colorCode,
      files: selectedUser.adminFiles,
      oldComment: selectedUser.adminComment,
      timestamp: selectedUser.updatedAt,
    };
    // const history = [currentStatus, ...(selectedUser.actionHistory ?? [])];
    const history = selectedUser?.actionHistory ?? [];
    const sotrtedHistory = [...history].sort(
      (a, b) => new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime(),
    );

    const historyWithPrevStatus = [currentStatus, ...sotrtedHistory].map((item, index, arr) => {
      if (index === arr.length - 1) {
        return { ...item, actionNamePrev: null, prevColorCode: null };
      }
      return {
        ...item,
        actionNamePrev: arr[index + 1].actionName || null,
        prevColorCode: arr[index + 1].colorCode || null,
      };
    });
    setHistoryStatusDetails(historyWithPrevStatus);
    setIsOpenHistoryModal(true);
  };
  const handleFilesSelected: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    const files = Array.from(e.target.files ?? []);
    if (!files.length) return;
    const { valid, errors } = validateImages(files, t);
    setUploadErrors(errors);
    if (valid.length) addFiles(valid);
    if (fileInputRef.current) fileInputRef.current.value = '';
  };

  const handleRemovePreview = (p: PreviewItem) => {
    removePreview(p);
  };

  const handleSubmitComment = async () => {
    try {
      setShowAddDetailsModal(false);
      await submitComment({
        crmControlId,
        comment,
        selectedAction,
        newFiles,
        crmItemSource,
      });

      clearNonExisting();
    } catch (error) {
      console.log('error', error);
    } finally {
      setComment('');
      setPreviewFiles([]);
      setSelectedAction(null);
      setCrmItemSource('');
      setNewActionName('');
      setLastAddedAction(null);
    }
  };

  const handleOpenNewActionModal = () => {
    setIsEditingAction(false);
    setEditActionName('');
    setChosenColor('#ffffff');
    // setColorInputValue('#ffffff');
    setOpenNewActionModal(true);
  };

  const modalData = {
    isOpen: openNewActionModal,
    center: true,
    toggler: () => setOpenNewActionModal(!openNewActionModal),
  };
  const handleSaveNewAction = async () => {
    setValidationError('');
    const color = chosenColor;
    const name = newActionName?.trim();
    validateStatusData(name, color);

    try {
      setOpenNewActionModal(false);
      const res = await addNewStatus({
        newAction: name,
        colorInputValue: color,
      });
      const added = {
        id: res.id,
        statusName: res.statusName ?? name,
        colorCode: res.colorCode ?? color,
        source: res.source ?? '',
      };

      // setSelectedStatus(null);
      setLastAddedAction(added);
      setNewActionName('');
    } catch (err) {
      console.error('failed to add action', err);
    }
  };

  const handleCommentModalClose = () => {
    setShowAddDetailsModal(false);
    setComment('');
    setPreviewFiles([]);
    setCrmItemSource('');
  };
  const hideCommentModal = () => {
    setShowAddDetailsModal(false);
  };
  const handleStatusEdit = async (
    id: number,
    statusName: string,
    colorCode: string,
    source?: string,
  ) => {
    setIsEditingAction(true);
    setEditActionName(statusName || '');
    setChosenColor(colorCode);
    // setColorInputValue(colorCode || '#ffffff');
    hideCommentModal();
    await new Promise((r) => setTimeout(r, 500));
    setOpenNewActionModal(true);
  };

  const handleConfirmedStatusDelete = async (id: number) => {
    try {
      await deleteStatusConfirmed({
        actionId: id,
      });

      setChosenColor('#ffffff');
      // setColorInputValue('#ffffff');
      setOpenNewActionModal(false);
    } catch (error) {
      console.log('error', error);
      setChosenColor('#ffffff');
      // setColorInputValue('#ffffff');
      setOpenNewActionModal(false);
    }
  };

  const handleStatusDelete = async (id: number, source?: string) => {
    hideCommentModal();
    await new Promise((r) => setTimeout(r, 500));
    try {
      Swal.fire({
        title: t('global.statusMutationsText.titleDelete'),
        text: t('global.statusMutationsText.textDelete'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: t('global.yes'),
        cancelButtonText: t('global.no'),
      }).then(async (result) => {
        if (result.isConfirmed) {
          await handleConfirmedStatusDelete(id);
        } else if (result.isDismissed) {
          await new Promise((r) => setTimeout(r, 300));
          setShowAddDetailsModal(true);
        }
      });
    } catch (error) {
      console.log('deleteCrmStatus error', error);
      Swal.fire({
        title: t('global.statusMutationsText.errorTitleDelete'),
        text: t('global.statusMutationsText.errorTextDelete'),
        icon: 'error',
      });
    }
  };

  const handleSaveEditAction = async ({
    status,
    name,
    color,
  }: {
    status: { id: number; statusName: string; colorCode: string } | null;
    name: string;
    color: string;
  }) => {
    setValidationError('');
    const trimmedName = name?.trim() || '';

    if (!trimmedName) {
      setValidationError(t('global.selector.nameRequired') || 'Name is required');
      return;
    }
    const onSuccessCb = () => {
      setShowAddDetailsModal(true);
    };
    const onErrorCb = () => {
      setShowAddDetailsModal(true);
    };
    try {
      setOpenNewActionModal(false);
      await new Promise((r) => setTimeout(r, 500));
      const result = await Swal.fire({
        title: t('global.statusMutationsText.titleEdit'),
        text: t('global.statusMutationsText.textEdit'),
        icon: 'warning',
        confirmButtonText: t('global.ok'),
        cancelButtonText: t('global.cancel'),
        showCancelButton: true,
      });
      if (result.isConfirmed) {
        await saveEditStatus({
          selectedAction: status,
          editAction: trimmedName,
          colorInputValue: color,
          onSuccessCb,
          onErrorCb,
        });
      } else if (result.isDismissed) {
        await new Promise((r) => setTimeout(r, 500));
        setShowAddDetailsModal(true);
      }
    } catch (err) {
      console.error('failed to edit action', err);

      setIsEditingAction(false);
      setEditActionName('');
      setChosenColor('#ffffff');
      // setColorInputValue('#ffffff');
      // setOpenNewActionModal(false);
    }
  };
  return (
    <>
      <Breadcrumbs mainTitle={t('control.title')} tooltip={<CrmHeadingTooltip />} />
      <Container fluid>
        <Card>
          <CardBody>
            <Nav tabs className="simple-wrapper mt-3">
              {crmControlStatuses?.map((item: CrmControlStatus, index: number) => (
                <NavItem key={index}>
                  <NavLink
                    tag="button"
                    type="button"
                    className={`txt-info !h4 f-w-500 ${statusFilter?.id === item.id ? 'active' : ''}`}
                    onClick={() => {
                      setStatusFilter({ id: item.id });
                      localStorage.setItem('stored-crm-control-status-tabs', `${item.id}`);
                    }}
                  >
                    {t(`global.selectorStatus.${item.statusName}`, {
                      defaultValue: item.statusName,
                    })}{' '}
                    ({item.totalCount})
                  </NavLink>
                </NavItem>
              ))}
              <NavItem key={0}>
                <NavLink
                  tag="button"
                  type="button"
                  className={`txt-info !h4 f-w-500 ${statusFilter?.id === 0 ? 'active' : ''}`}
                  onClick={() => {
                    setStatusFilter({ id: 0 });
                    localStorage.setItem('stored-crm-control-status-tabs', `0`);
                  }}
                >
                  {t(`global.selectorStatus.all`)} (
                  {crmControlStatuses?.reduce(
                    (acc: number, item: CrmControlStatus) => acc + item.totalCount,
                    0,
                  )}
                  )
                </NavLink>
              </NavItem>
            </Nav>
            <CrmControlTable
              overdues={overdues}
              totalRows={totalRows}
              page={page}
              setPage={setPage}
              perPage={perPage}
              setPerPage={setPerPage}
              sort={sort}
              setSort={setSort}
              sortKey={sortKey}
              setSortKey={setSortKey}
              search={search}
              setSearch={setSearch}
              viewerTz={viewerTz}
              handleModalOpen={handleModalOpen}
              handleHistoryOpen={handleHistoryOpen}
              t={t}
            />
          </CardBody>{' '}
        </Card>
        <CommentFileModal
          isOpen={showAddDetailsModal}
          onClose={handleCommentModalClose}
          labels={{
            title: t('leads.commentForm.label'),
            placeholder: '',
            ok: t('global.ok'),
            saving: t('global.saving'),
            cancel: t('global.cancel'),
            remove: t('common.remove'),
            examHandled: t('leads.examHandled'),
            yes: t('exams.yes'),
            no: t('exams.no'),
            selectStatus: t('global.selector.selectStatus'),
          }}
          commentRef={commentRef as React.RefObject<HTMLTextAreaElement>}
          comment={comment}
          onCommentChange={setComment}
          hasFileInput={true}
          fileInputRef={fileInputRef as React.RefObject<HTMLInputElement>}
          onFilesSelected={handleFilesSelected}
          previews={previews}
          onRemovePreview={handleRemovePreview}
          uploadErrors={uploadErrors}
          submitting={submitting}
          onSubmit={handleSubmitComment}
          filesRequired={false}
          dropDown={true}
          dropDownContent={dropDownContentForModal}
          dropDownPreSelected={
            selectedAction
              ? {
                  id: selectedAction.id,
                  statusName: selectedAction.statusName,
                  colorCode: selectedAction.colorCode,
                }
              : null
          }
          addOptionHandler={handleOpenNewActionModal}
          dropDownSelectHandler={setSelectedAction}
          isClearable={false}
          commentRequired={true}
          handleStatusEdit={handleStatusEdit}
          handleStatusDelete={handleStatusDelete}
          // dropDownAddValueHandler={handleDropDownAddValue}
        />
        <StatusHistoryModal
          isOpen={isOpenHistoryModal}
          close={() => setIsOpenHistoryModal(false)}
          size="xl"
          tableData={historyStatusDetails}
          columns={getCrmControlHistoryTableColumns(t, viewerTz)}
          defaultSortFieldId={'timestamp'}
          defaultSortAsc={false}
          hasFilter={false}
        />
        {/* <SimpleModal
          isOpen={isOpenHistoryModal}
          close={() => setIsOpenHistoryModal(false)}
          size="xl"
        >
          <AjaxSourcedData
            data={historyStatusDetails}
            columns={getCrmControlHistoryTableColumns(t, viewerTz)}
            defaultSortFieldId={'timestamp'}
            defaultSortAsc={false}
            hasFilter={false}
            noDataComponent={<NoDataComponent />}
          />
        </SimpleModal> */}
        <StatusEditorModal
          modalData={modalData}
          selectedStatus={
            isEditingAction && selectedAction
              ? {
                  id: selectedAction.id,
                  statusName: selectedAction.statusName,
                  colorCode: selectedAction.colorCode,
                }
              : null
          }
          crmControlStatuses={crmControlStatuses}
          onSave={isEditingAction ? handleSaveEditAction : handleSaveNewAction}
          onCancel={() => setOpenNewActionModal(false)}
          onDelete={() => selectedAction && handleStatusDelete(Number(selectedAction.id))}
          name={isEditingAction ? editActionName : newActionName}
          setName={isEditingAction ? setEditActionName : setNewActionName}
          color={chosenColor}
          setColor={setChosenColor}
          validationError={validationError}
          // handleSaveEditStatus={handleSaveEditAction}
          // handleSaveNewStatus={handleSaveNewAction}
        />
      </Container>
    </>
  );
};

export default CrmComntrol;
